import { NavigationGuard } from 'vue-router';
import store from '@/store';
import { RouteNames } from '@/utils/router/router.models';
import { tRoute } from '../plugins/i18nRoutes';

export const contactGuard: NavigationGuard = async (_to, _from, next) => {
  if (!store.state.configuration.houseConfiguration?.baufritzCode) {
    next(tRoute(RouteNames.Home));
  } else {
    next();
  }
};
